import Breadcrumb from "components/Common/Breadcrumb";
import React, { useEffect, useMemo, useState } from "react";
import {  Card, CardBody, Col, Label, Row } from "reactstrap";
import "moment/locale/en-gb";
import moment from "moment-timezone";
import "moment-timezone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AdminService } from "services/AdminService";
import { Report } from "models/Report";
import TableContainer from "components/Common/TableContainer";
// import DriverInvoiceView from "./DriverInvoiceView";
import { toast } from "react-toastify";
toast.configure();
import "react-toastify/dist/ReactToastify.css";
import { Puff } from "react-loader-spinner";
import AsyncSelect from "react-select/async"; // Import async select

const OrderReports: React.FC = () => {
  const [startDate, setStartDate] = useState(moment.tz("America/Toronto").startOf("month"));
  const [endDate, setEndDate] = useState(moment.tz("America/Toronto"));

  const [showTable, setShowTable] = useState(false);
  const [orderReport, setOrderReport] = useState([] as Report[]);
  const [isloading, setIsloading] = useState<boolean>(true);
  // const [modal, setModal] = useState(false);
  const [viewMode, setViewMode] = useState<"month" | "year">("month"); // View mode state
  const [selectedCustomer, setSelectedCustomer] = useState<{ value: string; label: string } | null>(null);

  const data = {
    date1: startDate,
    date2: endDate,
  };

  useEffect(() => {
    fetchReportData(viewMode);
  }, [viewMode, showTable]);

  // const fetchReportData = (mode: "month" | "year") => {
  //   setIsloading(true);
  //   AdminService.getOrderReport(data)
  //     .then(res => {
  //       if (res.success) {
  //         setOrderReport(mode === "month" ? res.data.monthReportList : res.data.yearReportList);
  //       }
  //     })
  //     .catch(error => {
  //       console.error("Error fetching report data:", error);
  //     })
  //     .finally(() => setIsloading(false));
  // };
  // const fetchReportData = (mode: "month" | "year") => {
  //   setIsloading(true);
  
  //   const requestData = {
  //     date1: startDate,
  //     date2: endDate,
  //     customerId: selectedCustomer ? selectedCustomer.value : "", // Send customer ID only if selected
  //   };
  
  //   AdminService.getOrderReport(requestData)
  //     .then(res => {
  //       if (res.success) {
  //         setOrderReport(mode === "month" ? res.data.monthReportList : res.data.yearReportList);
  //       }
  //     })
  //     .catch(error => {
  //       console.error("Error fetching report data:", error);
  //     })
  //     .finally(() => setIsloading(false));
  // };




  const fetchReportData = (mode: "month" | "year", customerId?: string) => {
    setIsloading(true);
  
    const requestData = {
      date1: startDate,
      date2: endDate,
      customerId: customerId || "", // Use customerId parameter instead of state
    };
  
    console.log("Sending API Request with Data:", requestData); // Debugging log
  
    AdminService.getOrderReport(requestData)
      .then(res => {
        if (res.success) {
          setOrderReport(mode === "month" ? res.data.monthReportList : res.data.yearReportList);
        }
      })
      .catch(error => {
        console.error("Error fetching report data:", error);
      })
      .finally(() => setIsloading(false));
  };
  
  
  // const handleCustomerSelect = (customer: { value: string; label: string } | null) => {
  //   setSelectedCustomer(customer);
  //   console.log("Selected Customer:", customer);
  //   fetchReportData(viewMode); // Fetch report data when a customer is selected
  // };
  
  const handleCustomerSelect = (customer: { value: string; label: string } | null) => {
    console.log("Selected Customer Before State Update:", customer); // Debugging log
  
    setSelectedCustomer(customer); // Update selected customer state
  
    // Use callback to ensure the latest state is used in fetchReportData
    setTimeout(() => {
      console.log("Fetching Data for Customer:", customer);
      fetchReportData(viewMode, customer?.value || ""); // Pass customer ID explicitly
    }, 100);
  };
  

  const loadCustomerOptions = async (inputValue: string) => {
    if (!inputValue) return [];
  
    try {
      const response = await AdminService.searchCustomersByName(inputValue, 0, 10);
      console.log("API Response:", response);
  
      if (response.success && response.data.length > 0) {
        const options = response.data.map((customer: { _id: string; firstName: string; lastName: string }) => ({
          value: customer._id, // Use _id as the unique identifier
          label: `${customer.firstName} ${customer.lastName}`, // Combine first and last name
        }));
  
        console.log("Dropdown Options:", options);
        return options;
      }
      
      return [];
    } catch (error) {
      console.error("Error fetching customers:", error);
      return [];
    }
  };
  

  const searchTable = (serchText: string) => {
    const searchdata = {
      date1: startDate,
      date2: endDate,
      status: "pending",
      searchableString: serchText,
    };

    AdminService.getDriverBillingBySearch(searchdata).then(res => {
      if (res.success) {
        if (res.data.length !== 0) {
          // setDriverBills(res.data);
        }
      }
    });
  };

  const handleStartDate = (date: Date | null) => {
    const sDate = moment(date);
    setStartDate(sDate);
  };

  const handleEndDate = (date: Date | null) => {
    const eDate = moment(date);
    setEndDate(eDate);
  };

  const exportToCsv = (data: Report[], fileName: string) => {
    if (!data || !data.length) {
      alert("No data available to export.");
      return;
    }


    const headers = Object.keys(data[0]);


    const csvContent =
      [headers.join(",")] + 
      "\n" +
      data
        .map(row =>
          headers
            .map(
              fieldName => JSON.stringify((row as Record<string, unknown>)[fieldName]?? "") 
            )
            .join(",")
        )
        .join("\n");

  
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // const generateInvoice = () => {
  //   AdminService.sendDriverBillingInvoices(data)
  //     .then(res => {
  //       if (res.success) {
  //         setDriverBills(res.data);
  //         toast.success("Successfully generated invoices.", {
  //           position: toast.POSITION.BOTTOM_RIGHT,
  //           className: "foo-bar",
  //           style: { marginBottom: "4rem" },
  //         });
  //       } else {
  //         toast.info("There are no pending driver billing invoices.", {
  //           position: toast.POSITION.BOTTOM_RIGHT,
  //           className: "foo-bar",
  //           style: { marginBottom: "4rem" },
  //         });
  //       }
  //     })
  //     .catch(error => {
  //       console.error(error);
  //     });
  // };

  // const handlePopup = () => {
  //   setModal(!modal);
  // };

  // const handleViewInvoice = (values: any) => {
  //   setDriverBill(values?.original);
  //   handlePopup();
  // };

  const handleViewModeChange = (mode: "month" | "year") => {
    setViewMode(mode);
  };

  const columns = useMemo(() => {
    const baseColumns = [
      {
        id: "totalOrders",
        Header: "Total Orders",
        accessor: "totalOrders",
        Cell: ({ value }: { value: number | null }) => value !== undefined ? value : "N/A",
      },
      {
        id: "totalRevenue",
        Header: "Total Revenue",
        accessor: "totalRevenue",
        Cell: ({ value }: { value: number | null }) =>value !== undefined && value !== null ? `$${value.toFixed(2)}` : "N/A",
      },
    ];
    if (viewMode === "month") {
      return [
        {
          id: "month",
          Header: "Month",
          accessor: (row: Report) => `${row.year}-${String(row.month).padStart(2, "0")}`, // Combine year and month
          Cell: ({ value }: { value: string }) => {
            if (!value) return "N/A";
            const [year, month] = value.split("-");
            return `${month}/${year}`;
          },
        },
        ...baseColumns,
        {
          id: "monthChangeOrders",
          Header: "Order Changed %",
          accessor: "monthChangeOrders",
          Cell: ({ value }: { value: number | null }) => (value !== undefined && value !== null ? `${value.toFixed(2)}%` : "N/A"),
        },
        {
          id: "monthChangeRevenue",
          Header: "Revenue Changed %",
          accessor: "monthChangeRevenue",
          Cell: ({ value }: { value: number | null }) => (value !== undefined && value !== null ? `${value.toFixed(2)}%` : "N/A"),
        },
      ];
    }

    return [
      {
        id: "year",
        Header: "Year",
        accessor: "year", // Use only the year field
        Cell: ({ value }: { value: number | undefined }) => (value !== undefined ? value : "N/A"),
      },
      ...baseColumns,
      {
        id: "yearChangeOrders",
        Header: "Order Changed %",
        accessor: "yearChangeOrders",
        Cell: ({ value }:  { value: number | undefined }) => (value !== undefined && value !== null ? `${value.toFixed(2)}%` : "N/A"),
      },
      {
        id: "yearChangeRevenue",
        Header: "Revenue Changed %",
        accessor: "yearChangeRevenue",
        Cell: ({ value }:  { value: number | undefined }) => (value !== undefined && value !== null ? `${value.toFixed(2)}%` : "N/A"),
      },
    ];
  }, [viewMode]);

  document.title = "Order Reports | Zulu Courier";

  return (
    <React.Fragment>
      <div className="page-content mb-5">
        <div className="container-fluid mb-5">
          <Breadcrumb title="Order Reports" breadcrumbItem="Order Reports" />
          <Row >
            <Col lg="12">
              <Card className="mb-5 bg-m-none">
                <CardBody>
                  <div className="wizard clearfix mb-5">
                    <Row>
                        {/* 🔹 Searchable Customer Dropdown */}
                      <Col lg="2">
                        {/* <Label>Select Customer</Label> */}
                        <AsyncSelect
                          cacheOptions
                          loadOptions={loadCustomerOptions} // Function to load customers dynamically
                          onChange={handleCustomerSelect}
                          placeholder="Search for a customer..."
                          isClearable
                          className="mb-2"
                          value={selectedCustomer}
                        />
                      </Col>

                    <Col lg="2">
                      <select
                        value={viewMode}
                        onChange={e => handleViewModeChange(e.target.value as "month" | "year")}
                        className="form-select mb-2"
                        style={{ width: "200px" }}
                      >
                        <option value="month">Month </option>
                        <option value="year">Year </option>
                      </select>
                      </Col>
                      <Col lg="2" className="h-100">
                        <DatePicker
                          onFocus={e => e.target.blur()}
                          selected={startDate ? startDate.toDate() : null}
                          onChange={handleStartDate}
                          dateFormat={viewMode === "month" ? "MMMM yyyy" : "yyyy"}
                          showMonthYearPicker={viewMode === "month"}
                          showYearPicker={viewMode === "year"}
                          maxDate={viewMode === "month" ? new Date() : new Date()}
                          className="form-control mb-2"
                        />
                      </Col>
                      <Col lg="1" className="text-center">
                        <Label className="mt-lg-2">To</Label>
                      </Col>
                      <Col lg="2">
                        <DatePicker
                          onFocus={e => e.target.blur()}
                          selected={endDate ? endDate.toDate() : null}
                          onChange={handleEndDate}
                          dateFormat={viewMode === "month" ? "MMMM yyyy" : "yyyy"}
                          showMonthYearPicker={viewMode === "month"}
                          showYearPicker={viewMode === "year"}
                          maxDate={viewMode === "month" ? new Date() : new Date()}
                          className="form-control mb-2"
                        />
                      </Col>
                      <Col lg="1">
                        <button type="submit"  onClick={() => {
                          setShowTable(!showTable);
                          setSelectedCustomer(null); 
                          }} className="btn btn-primary btn-sm px-3 me-2 mt-lg-2">
                          Filter
                        </button>
                      </Col>

                      <Col lg="2" className="text-right">
                        <button className="btn btn-primary btn-sm px-3 me-2 mt-2 mt-lg-2" onClick={() => exportToCsv(orderReport, "Filtered_Report")}>
                          Export CSV
                        </button>
                      </Col>
                    </Row>
                  </div>

                  <div className="wizard clearfix">
                    <Label>Order Reports</Label>
                    <Row>
                      <Col lg="12">
                        {isloading ? (
                          <div className="d-flex justify-content-center align-items-center" style={{ height: "500px" }}>
                            <Puff color="#FFD0B8" height={50} width={50} />
                          </div>
                        ) : (
                          <>
                            {orderReport !== undefined && orderReport ? (
                              <TableContainer
                                  columns={columns}
                                  data={orderReport}
                                  currentPage={undefined}
                                  pagelimit={undefined}
                                  handlePageChange={undefined}
                                  handleColumnChange={undefined}
                                  selectedColumns={undefined}
                                  showColumnChange={false}
                                  handleSearch={searchTable}
                                  isGlobalFilter={true}
                                  isAddOptions={false}
                                  customPageSize={10}
                                  className="custom-header-css"
                                  isJobListGlobalFilter={undefined}
                                  isAddUserList={undefined}
                                  handleOrderClicks={undefined}
                                  handleUserClick={undefined}
                                  handleCustomerClick={undefined}
                                  isAddCustList={undefined}
                                  handleSendEmail={undefined}
                                  isPDFGenerate={false}
                                  ispopup={false}
                                  isAddressBook={false}
                                  hancleDeleteRecords={undefined}
                                  handleSelect={undefined}
                                  selectedID={undefined}
                                  hasCheckBox={false} footerData={undefined}                              />
                            ) : (
                              <Row className="justify-content-md-center justify-content-center align-items-center mb-5">
                                <Col className="col-md-auto">
                                  <div>No Order Reports</div>
                                </Col>
                              </Row>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* <DriverInvoiceView isOpen={modal} handlePopup={handlePopup} driverBill={driverBill} dates={data} /> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrderReports;
